import { useTranslation } from 'react-i18next';
import type { ClientCustomerType } from '@econtractor/types';
import type { NewObjectType } from 'modules/lead';
import { type NewSaleType, isCustomerPersonType } from 'modules/objects';
import ClientCustomerAction, { type ClientCustomerActionClient } from '../ClientCustomerAction';

interface ClientCustomersTableRowProps {
    row: ClientCustomerType;
    onEdit: (row: ClientCustomerType) => void;
    onDelete: (row: ClientCustomerType) => void;
    onCreateSale?: (sale: NewSaleType) => void;
    onCreateObject?: (object: NewObjectType) => void;
    client?: ClientCustomerActionClient;
}

const ClientCustomersTableRow = ({
    row,
    onEdit,
    onDelete,
    onCreateSale,
    onCreateObject,
    client,
}: ClientCustomersTableRowProps) => {
    const { t } = useTranslation(['Objects']);

    const personType = row.customer?.personType;
    const personTypeLabel = isCustomerPersonType(personType)
        ? t(`customer.personTypes.${personType}`)
        : personType || '-';

    return (
        <tr className="cursor-pointer" onClick={() => onEdit(row)}>
            <td className="name text-break">{row.fullName || '-'}</td>
            <td className="article text-break">{row.edrpouOrIpn || '-'}</td>
            <td className="status">{personTypeLabel}</td>
            <td className="action" onClick={(e) => e.stopPropagation()}>
                <ClientCustomerAction
                    row={row}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    onCreateSale={onCreateSale}
                    onCreateObject={onCreateObject}
                    client={client}
                />
            </td>
        </tr>
    );
};

export default ClientCustomersTableRow;
